// apps/app/src/components/builder/useChartRecommendations.ts
import { useMemo } from "react"
import type { Fingerprint, RoleState, RecommendResult } from "./recommendCharts"
import { recommendCharts } from "./recommendCharts"

export function useChartRecommendations(
  fp: Fingerprint | null,
  roles: RoleState
): RecommendResult {
  // Memoize based on the fields that matter.
  // If your fingerprint object identity is unstable, consider passing fpHash separately.
  const y = roles.y
  const yKey = Array.isArray(y) ? y.join("|") : (y ?? "")

  return useMemo(() => {
    return recommendCharts(fp, roles)
  }, [
    fp?.rows,
    fp?.columns,
    fp?.suggestions,
    roles.x,
    yKey,
    roles.series,
    roles.facet,
    roles.uncertainty,
    roles.n,
  ])
}
